import $ from 'jquery';
import List from 'list.js';

export default {
    init() {
        // JavaScript to be fired on all pages
        const h = $(window).outerHeight() - 472;
        $('#main').css('min-height', h);
        //Begin Project list function
        var options = {
            valueNames: [
                {data: ['project']},
            ],
            page: $('#project-lists .list').data('number'),
            pagination: [{
                innerWindow: 1,
            }],
        };
        var projectList = new List('project-lists', options);
        if ($('#project-lists').length) {
            setTimeout(function () {
                $('#init-loading').hide();
                $('#project-lists .columns.col-md-6').fadeIn();
                checkPagination();
            }, 1000);
        }

        function updateListProject(project_cat) {
            $('#loading').show();
            projectList.filter(function (item) {
                var catFilter = false;

                if (project_cat === 'all') {
                    catFilter = true;
                } else {
                    catFilter = item.values().project == project_cat;
                }
                return catFilter;
            });
            projectList.update();
        }

        projectList.on('updated', function (list) {
            $('#loading').hide();
            $('#project-lists .columns.col-md-6').fadeIn();
            scrollToTop();
            checkPagination();
            if (list.matchingItems.length > 0) {
                $('.no-results').hide();
            } else {
                $('.no-results').show();
            }
        });

        function checkPagination() {
            if ($('#project-lists .pagination li').length > 1) {
                $('#project-lists .pagination').css('display', 'flex');
            } else {
                $('#project-lists .pagination').css('display', 'none');
            }
        }

        //End Project list function
        $('.header__link-panel').on('click', function () {
            $(this).toggleClass('active');
            $('#main-menu').toggleClass('open');
        });

        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);

        window.addEventListener('resize', () => {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        });

        $('.gallery-block').magnificPopup({
            delegate: '.gallery-block__item',
            type: 'image',
            tLoading: 'Loading image #%curr%...',
            mainClass: 'mfp-img-mobile',
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0, 1],
            },
            image: {
                titleSrc: function (item) {
                    var $gallery = $('.gallery-block');
                    var $result = '';
                    if ($gallery.find('.columns').length > 0) {
                        $result = '<div class="mfp-info">' +
                            '<ul class="mfp-info__dots" style="display: inline-block;">';
                        for (var i = 0; i < $gallery.find('.columns').length; i++) {
                            var $cl_active = '';
                            if (item.index == i) $cl_active = ' class="active"'; else $cl_active = '';
                            $result += '<li' + $cl_active + '>' +
                                '<button type="button" onclick="javascript:jQuery(\'.gallery-block\').magnificPopup(\'goTo\', ' + i + ');return false;"></button>' +
                                '</li>';
                        }
                        $result += '</ul>' +
                            '</div>' +
                            '</div>';
                    }
                    return $result;
                },
            },
        });

        var $select = $('.gform_wrapper select'), timeout;

        if ($select.length) {
            $(window).on('resize.select2', function () {
                clearTimeout(timeout);

                timeout = setTimeout(function () {
                    $select.select2({
                        minimumResultsForSearch: Infinity,
                        width: '100%',
                    });
                }, 200);
            }).trigger('resize.select2');
        }

        const _scrollEffect = function () {
            var st = $(window).scrollTop();
            if (st > 200) {
                $('#wrapper').addClass('scroll');
            } else {
                $('#wrapper').removeClass('scroll');
            }
        };

        $('.sidebar__list-more').on('click', function () {
            $(this).toggleClass('active');
            $(this).next().slideToggle();
        });

        function _wrapTable() {
            let $element = $('.wp-editor table');
            $element.wrap('<div class="table-scroll"/>');
        }

        function _slider() {
            $('.partner-block__slider').owlCarousel({
                loop: true,
                nav: true,
                dots: false,
                responsive: {
                    0: {
                        items: 1,
                    },
                    600: {
                        items: 2,
                        margin: 50,
                    },
                    992: {
                        items: 3,
                        margin: 50,
                    },
                },
                autoplay: true,
                autoplayTimeout: 4000,
            });

            $('.quotes-block__slider').owlCarousel({
                loop: true,
                nav: false,
                dots: true,
                items: 1,
                autoplay: true,
                autoplayTimeout: 10000,
            });
        }

        function _bindEvent() {
            $('.show-more span').on('click', function () {
                $(this).toggleClass('active');
                $(this).parent().next().slideToggle();
            });
        }

        _wrapTable();
        _scrollEffect();
        _slider();
        _bindEvent()

        $(window).on('scroll', function () {
            _scrollEffect();
        });

        // click to show product
        $(document).on('click', '.list-cat li a', function (e) {
            e.preventDefault();
            var $parent = $($(this).parent()).parent().attr('class');
            $('.list-cat').find('a').removeClass('active');
            $(this).addClass('active');
            var $slug = $(this).attr('data-slug');
            var $number = $('.ajax_content').attr('data-number');
            if ($parent == 'news-overview__nav') {
                actionAjax($number, $slug, 'dev_load_new');
            } else {
                // actionAjax($number, $slug, 'dev_load_project');
                updateListProject($(this).data('id'));
            }
        });

        $(document).on('click', '.page-numbers', function (e) {
            e.preventDefault();
            var $page = $(this).text();
            $page = $page.slice(0, -1);
            var $slug = $('.list-cat li a.active').attr('data-slug');
            var $number = $('.ajax_content').attr('data-number');
            var $type = $('.list-cat ul').attr('class');
            if ($type == 'portfolio-preview__nav') {
                // actionAjax($number, $slug, 'dev_load_project', $page);
                updateListProject($(this).data('id'));
            } else {
                actionAjax($number, $slug, 'dev_load_new', $page);
            }
        });

        function actionAjax($number = 10, $slug = '', $action = '', $page = 1) {
            const ajax_url = window.dev_ajax.ajax_url || false;
            if (ajax_url) {
                $.ajax({
                    method: 'POST',
                    url: ajax_url,
                    data: {number: $number, cat: $slug, action: $action, page: $page},
                    beforeSend: function () {
                        $('#loading').show();
                    },
                    success: function (result) {
                        $('.ajax_content').html(result);
                        $('#loading').hide();
                        scrollToTop();
                    },
                });
            }
        }

        function scrollToTop() {
            var body = $('html, body');
            body.stop().animate({scrollTop: ($('.list-cat').offset().top - 200)}, 400, 'swing');
        }

    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js